<script>
// Copied from organization/staffCalendar/EditStaffColorModal.vue and
// adapted to an "agent" prop and the calendar's own colour map
// (agentColorMap.js) — see CLAUDE.md's "copy and adapt, don't share" note.
import BaseModal from 'dashboard/components/dahreply/BaseModal.vue';
import { useAlert } from 'dashboard/composables';

export default {
  name: 'AgentColorModal',

  components: {
    BaseModal,
  },

  props: {
    agent: {
      type: Object,
      required: true,
    },
    currentColor: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      selectedColor: this.currentColor,
      isLoading: false,
    };
  },

  methods: {
    handleConfirm() {
      this.isLoading = true;
      this.$emit('save', this.agent.agent_id, this.selectedColor);
      this.isLoading = false;
      useAlert(this.$t('REAL_ESTATE.CALENDAR.COLOR_UPDATED'));
      this.$emit('close');
    },
  },
};
</script>

<template>
  <BaseModal @close="$emit('close')">
    <template #title>
      {{ $t('REAL_ESTATE.CALENDAR.COLOR_MODAL_TITLE') }}
    </template>

    <div class="space-y-4">
      <div>
        <p class="text-sm font-medium text-slate-900 dark:text-slate-100">
          {{ agent.name }}
        </p>
        <p class="text-xs text-slate-500 dark:text-slate-400">
          {{ $t('REAL_ESTATE.CALENDAR.COLOR_MODAL_HINT') }}
        </p>
      </div>

      <div class="flex items-center gap-4">
        <input
          v-model="selectedColor"
          type="color"
          class="w-10 h-10 rounded border border-slate-300 dark:border-slate-600 cursor-pointer"
        />
        <div
          class="px-3 py-2 rounded text-sm border border-slate-200 dark:border-slate-700"
        >
          {{ selectedColor }}
        </div>
      </div>
    </div>

    <template #footer>
      <div class="flex justify-end gap-3 mt-4">
        <woot-button
          color-scheme="secondary"
          :disabled="isLoading"
          @click="$emit('close')"
        >
          {{ $t('REAL_ESTATE.CALENDAR.CANCEL') }}
        </woot-button>
        <woot-button
          :loading="isLoading"
          :disabled="isLoading"
          @click="handleConfirm"
        >
          {{ $t('REAL_ESTATE.CALENDAR.UPDATE') }}
        </woot-button>
      </div>
    </template>
  </BaseModal>
</template>
